import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AppointmentModel } from "../models/MappointmentModel";
import { OPD_CONST } from "../properties/opd-static-properties";
import moment from "moment";

@Injectable()
export class AppointmentService {
  private values = new BehaviorSubject<any>({ selectedDate: "" });
  value = this.values.asObservable();

  setAppointmentData(value) {
    this.values.next(value);
  }
  setURlslotData(_this, startDate, endDate) {
    return `/slot/${_this.appointmentType}/Appointment/List?departmentCode=${_this.department}&startTime=${startDate}&endTime=${endDate}`;
  }
  setURLmultipleDoctor(_this, startDate, endDate) {
    return `/slot/${_this.appointmentType}/Appointment/List?entities=${_this.doctor.code}&departmentCode=${_this.department}&startTime=${startDate}&endTime=${endDate}`;
  }
  appoinmentSearchList(_this) {
    let searchList: any[] = [
      {
        controls: [
          // {
          //   type: "text",
          //   placeholder: _this.langService.get("SearchHeader.patientName"),
          //   value: "",
          //   column: 6,
          //   name: "PatientName",
          //   url: "",
          //   selectType: "",
          // },
          {
            "type": "text",
            "placeholder":_this.langService.get("SearchHeader.patientName"),
            "column": 6,
            "name": "PatientName"
  
          },
          {
            type: "text",
            placeholder: _this.langService.get("AppointmentListPage.mrn"),
            value: "",
            column: 6,
            name: "MRN",
            url: "",
            selectType: "",
          },
        ],
      },
      {
        controls: [
          {
            type: "select",
            placeholder: _this.langService.get("SearchHeader.idType"),
            value: "",
            column: 6,
            name: "identificationType",
            url: "masters-service/Masters/IdentificationTypeMaster",
            selectType: "",
          },
          {
            type: "text",
            placeholder: _this.langService.get("SearchHeader.docNo"),
            value: "",
            column: 6,
            name: "identificationNumber",
            url: "",
            selectType: "",
          },
        ],
      },
      {
        controls: [
          {
            type: "number",
            placeholder: _this.langService.get("RegistrationPage.handphoneNo"),
            value: "",
            column: 6,
            name: "MobileNo",
            url: "",
            selectType: "",
          },
          {
            type: "date",
            placeholder: _this.langService.get("AppointmentPage.dob"),
            column: 6,
            name: "dob",
          },
        ],
      },
    ];
    return searchList;
  }
    getWaitingSearchList(_this) {
    let searchList: any[] = [ 
      {
        controls: [
          {
            type: "select",
            placeholder: _this.langService.get(
              "AppointmentPage.appointmenttype"
            ),
            url: "masters-service/Masters/AppointmentTypeMaster",
            column: 6,
            name: "AppointmentType",
            isFrontendFlag: true
          },
          {
            type: "select",
            placeholder: _this.langService.get("AppointmentPage.department"),
            url: "masters-service/Masters/DepartmentMaster",
            column: 6,
            name: "Department",
          },
        ],
      },
      {
        controls: [
          {
            type: "select",
            placeholder: _this.langService.get("AppointmentListPage.doctor"),
            url: "masters-service/Masters/EmployeeMasterDetails/query?field=typeId.code&value=DR",
            column: 6,
            name: "Doctor",
          },
          {
            type: "text",
            placeholder: _this.langService.get("AppointmentListPage.mrn"),
            column: 6,
            name: "MRN",
          },
        ],
      },

      {
        controls: [
          {
            type: "text",
            placeholder: _this.langService.get("SearchHeader.patientName"),
            column: 6,
            name: "PatientName",
          },
          {
            type: "select",
            placeholder: _this.langService.get("AppointmentListPage.status"),
            url: "masters-service/BedStatus/getStatusByScreenId/8",
            column: 6,
            name: "Status",
          },
        ],
      },
      {
        controls: [
          {
            type: "dateRange",
            placeholder: _this.langService.get(
              "AppointmentListPage.appointmentFromTo"
            ),
            column: 12,
            name: "dateRange",
          },
        ],
      },
    ];
    return searchList;
  }
  getappointmentSearchList(_this) {
    let searchList: any[] = [ 
      {
        controls: [
          {
            type: "select",
            placeholder: _this.langService.get(
              "AppointmentPage.appointmenttype"
            ),
            url: "masters-service/Masters/AppointmentTypeMaster",
            column: 6,
            name: "AppointmentType",
            isFrontendFlag: true
          },
          {
            type: "select",
            placeholder: _this.langService.get("AppointmentPage.department"),
            url: "masters-service/Masters/DepartmentMaster",
            column: 6,
            name: "Department",
          },
        ],
      },
      {
        controls: [
          {
            type: "select",
            placeholder: _this.langService.get("AppointmentListPage.doctor"),
            url: "masters-service/Masters/EmployeeMasterDetails/query?field=typeId.code&value=DR",
            column: 6,
            name: "Doctor",
          },
          {
            type: "text",
            placeholder: _this.langService.get("AppointmentListPage.mrn"),
            column: 6,
            name: "MRN",
          },
        ],
      },

      {
        controls: [
          {
            type: "text",
            placeholder: _this.langService.get("SearchHeader.patientName"),
            column: 6,
            name: "PatientName",
          },
          {
            type: "select",
            placeholder: _this.langService.get("AppointmentListPage.status"),
            url: "masters-service/BedStatus/getStatusByScreenId/7",
            column: 6,
            name: "Status",
          },
        ],
      },
      {
        controls: [
          {
            type: "dateRange",
            placeholder: _this.langService.get(
              "AppointmentListPage.appointmentFromTo"
            ),
            column: 12,
            name: "dateRange",
          },
        ],
      },
    ];
    return searchList;
  }

  getappointmentRescheduleSearchList(_this) {
    let searchList: any[] = [
      {
        controls: [
          {
            type: "select",
            placeholder: _this.langService.get(
              "AppointmentPage.appointmenttype"
            ),
            url: "masters-service/Masters/AppointmentTypeMaster",
            column: 6,
            name: "AppointmentType",
            isFrontendFlag: true
          },
          {
            type: "select",
            placeholder: _this.langService.get("AppointmentPage.department"),
            url: "masters-service/Masters/DepartmentMaster",
            column: 6,
            name: "Department",
          },
        ],
      },
      {
        controls: [
          {
            type: "select",
            placeholder: _this.langService.get("AppointmentListPage.doctor"),
            url: "masters-service/Masters/EmployeeMasterDetails",
            column: 6,
            name: "Doctor",
          },
          {
            type: "text",
            placeholder: _this.langService.get("AppointmentListPage.mrn"),
            column: 6,
            name: "MRN",
          },
        ],
      },

      {
        controls: [
          {
            type: "text",
            placeholder: _this.langService.get("SearchHeader.patientName"),
            column: 6,
            name: "PatientName",
          },
        ],
      },
      {
        controls: [
          {
            type: "dateRange",
            placeholder: _this.langService.get(
              "AppointmentListPage.appointmentFromTo"
            ),
            column: 12,
            name: "dateRange",
          },
        ],
      },
    ];
    return searchList;
  }
  getstatusReqPayload(_this, startDate, endDate, isCount) {
    if (isCount)
      return `appointment/filter?fromDate=${startDate}&toDate=${endDate}&appointmentType=${_this.searchAppt.apptype}&speciality=${_this.searchAppt.dept}&doctor=${_this.searchAppt.doctor}&mrn=${_this.searchAppt.mrn}&patientName=${_this.searchAppt.pname}&groupedCount=true&consultationType=${_this.searchAppt.consultationType}&patientCategory=${_this.searchAppt.patientCategory}&calledStatus=${_this.searchAppt.calledStatus}&priority=${_this.searchAppt.priority}`;
    else
      return `appointment/filter?fromDate=${startDate}&toDate=${endDate}&appointmentType=${_this.searchAppt.apptype}&speciality=${_this.searchAppt.dept}&doctor=${_this.searchAppt.doctor}&mrn=${_this.searchAppt.mrn}&offset=${_this.offsetData}&size=${_this.pageSize}&patientName=${_this.searchAppt.pname}&businessStatus=${_this.searchAppt.status}&consultationType=${_this.searchAppt.consultationType}&patientCategory=${_this.searchAppt.patientCategory}&calledStatus=${_this.searchAppt.calledStatus}&priority=${_this.searchAppt.priority}`;
  }
  getrescheuleReqPayload(_this, startDate, endDate)
  {
    return`appointment/filter?fromDate=${startDate}&toDate=${endDate}&appointmentType=${_this.searchAppt.apptype}&speciality=${_this.searchAppt.dept}&doctor=${_this.searchAppt.doctor}&mrn=${_this.searchAppt.mrn}
    &offset=${_this.offsetData}
    &size=${_this.pageSize}
    &patientName=${_this.searchAppt.pname}&businessStatus=reschedule`;
  }
  getSearchPatient(partientSearch)
  {
    return `extendedPatient/filter?mrn=${partientSearch.MRN}&name=${
      partientSearch.PatientName
          }&identificationType=${
            partientSearch.identificationType.code
              ? partientSearch.identificationType.code
              : " "
          }&identificationId=${
            partientSearch.identificationNumber
          }&operation=search&mobile=${partientSearch.MobileNo}&birthDate=${
            partientSearch.birthDate
          }&offset=${partientSearch.offset}&size=${partientSearch.limit}&patientCategory=${partientSearch.patientCategory}`;
  }
  getappoitmentList(res, _this): AppointmentModel {
    let today = new Date().setHours(0, 0, 0, 0);
    let language = localStorage.getItem("lan");
    _this.totalDataLength = res.totalRecords;
    res.response.forEach((element) => {
      let checkIn = false;
      let mrn;
      let name;
      let dateofbirth = "";
      let mobileNO;
      let speciality = "";
      let packagelist ="";
      let patientType = element.patientType.code;
      let gender = "";
      let genderv = "";
      let dob: any;
      let patientTypemulti;
      let statusMultiLang;
      let patientId;
      let isSelcted;
      let doctorId = "";
      let doctorName = "";
      let countryCode = "";
      let patientResponse = '';
      let start = new Date(element.start).setHours(0, 0, 0, 0);
      let vipFlag = element.patient?element.patient.vip:false;     
      let token;
      let agecalculate="";
      let appointmentType="";
      let appointmentTypeCode="";
      let patientCategoryCode="";
      let calledStatus="";
      let appoinmentPriorityCode="";
      let priority="";
      let specialInstruction="";
      let needTranslator=false;
      let translatorLanguage="";
      let displayTitle= "";
      let patientNameLangBase =""
      if (patientType == OPD_CONST.appoinmentRef.temp) {
        mrn = element.mrn?element.mrn:element.temporaryPatient.trn?element.temporaryPatient.trn:null;
        name = element.participant[0].actor.display;
        countryCode =element.temporaryPatient?
        element.temporaryPatient.countryCode?element.temporaryPatient.countryCode.display :"":""; 
        patientResponse = element.patientResponse ? element.patientResponse : null;
        dob = _this.patientService.calculateAge(
          element.temporaryPatient ? element.temporaryPatient.birthDate : ""
        );
        agecalculate=element.temporaryPatient ? element.temporaryPatient.birthDate:"";
        dateofbirth =language=="th" ?_this.thConvertService.convertThaiDateString(element.temporaryPatient.birthDate):element.temporaryPatient ? element.temporaryPatient.birthDate : ""
        // (gender = element.temporaryPatient
        //   ? element.temporaryPatient.gender
        //     ? element.temporaryPatient.gender.display
        //     : ""
        //   : "")
          if (element.temporaryPatient.gender) {
            gender = element.temporaryPatient
          ? element.temporaryPatient.gender
            ? element.temporaryPatient.gender.display
            : ""
          : ""
            let gendervalue = gender
              .toString()
              .toUpperCase();
            genderv = gendervalue == "MALE" ? "M" : "F";
              
          }
    
          (patientTypemulti = _this.langService.get("CommonAppoinment.TEMP"));
          mobileNO= element.temporaryPatient? element.temporaryPatient.mobileNumber:"";
           token=element.token?element.token:'',
        appointmentType=element.appointmentVisitType?element.appointmentVisitType.display:"";
        appointmentTypeCode=element.appointmentVisitType?element.appointmentVisitType.code:"";
        patientCategoryCode=element.temporaryPatient?.patientCategory?.code ?? "";
        calledStatus = element.calledStatus ? element.calledStatus : "";
        appoinmentPriorityCode= element.priority? element.priority.code : "";
        priority= element.priority? element.priority.display : "";
        specialInstruction = element.specialInstruction? element.specialInstruction : "";
        needTranslator = element.needTranslator ? element.needTranslator : false;
        translatorLanguage = element.translatorLanguage ? element.translatorLanguage : "";
        displayTitle =  element.temporaryPatient? element.temporaryPatient.title?.display:"";
        patientNameLangBase = element.temporaryPatient? element.temporaryPatient.patientNameLangBase:"";
      } else {
        token=element.token?element.token:''
        countryCode =element.patient?element.patient.countryCode ?element.patient.countryCode.display :"":""; 
        patientId = element.patient?element.patient.id:'';
        patientResponse = element.patientResponse ? element.patientResponse : null;
        mrn = element.mrn?element.mrn:element.patient.identifier && element.patient.identifier[0]?element.patient.identifier[0].value:null;
        dob = _this.patientService.calculateAge(
          element.patient ? element.patient.birthDate : ""
        );
        agecalculate=element.patient ? element.patient.birthDate:"";
         dateofbirth = language=="th" ?_this.thConvertService.convertThaiDateString(element.patient.birthDate):element.patient ? element.patient.birthDate : ""
        name = element.participant[0].actor.display;
        (gender = element.patient ? ( element.patient.gender?element.patient.gender.display:"") : "")
        if (element.patient?element.patient.gender:false) {
          gender = element.patient.gender.display
            .toString()
            .toUpperCase();
          genderv = gender == "MALE" ? "M" : "F";
            
        }
  
          (patientTypemulti = _this.langService.get("CommonAppoinment.REG"));
          mobileNO=element.patient?element.patient.telecom[1]?element.patient.telecom[1].value:"":"";
          appointmentType=element.appointmentVisitType?element.appointmentVisitType.display:"";
          appointmentTypeCode=element.appointmentVisitType?element.appointmentVisitType.code:"";
          patientCategoryCode=element.patientCategory?element.patientCategory.code:"";
          calledStatus = element.calledStatus ? element.calledStatus : "";
          appoinmentPriorityCode= element.priority? element.priority.code : "";
        priority= element.priority? element.priority.display : "";
        specialInstruction = element.specialInstruction? element.specialInstruction : "";
        needTranslator = element.needTranslator ? element.needTranslator : false;
        translatorLanguage = element.translatorLanguage ? element.translatorLanguage : "";
        displayTitle =  element.patient? element.patient.title?.display:"";
        patientNameLangBase = element.patient? element.patient?.patientNameLangBase:"";
      }
      if (element.status == OPD_CONST.apppointmentListDisplay.booked && today === start) {
        checkIn = true;
      }
      if (element.businessStatus == OPD_CONST.apppointmentListDisplay.booked) {
        statusMultiLang = _this.langService.get("AppointmentListPage.booked");
        isSelcted = "booked";
      } else if (element.businessStatus == OPD_CONST.apppointmentListDisplay.arrived) {
        statusMultiLang = _this.langService.get("AppointmentListPage.arrived");
      } else if (element.businessStatus ==  OPD_CONST.apppointmentListDisplay.cancelled) {
        statusMultiLang = _this.langService.get(
          "AppointmentListPage.cancelled"
        );
      } else if (element.businessStatus == "NOSHOW") {
        statusMultiLang = "No Show"
      } else if (element.businessStatus == OPD_CONST.apppointmentListDisplay.rescheduled) {
        statusMultiLang = "Rescheduled"
      }
      else {
        statusMultiLang = _this.langService.get(
          "AppointmentListPage.cancelled"
        );
      }
      if (element.serviceCategory && element.serviceCategory.code == "1") {
        doctorId = element.participant[0].actor.reference;
        doctorName = element.participant[0].actor.display;
      }
      if (element.specialRequirements) {
        element.specialRequirements.forEach((res) => {
          speciality += res.display + " , ";
        });
      }
      if (element.packageList) {
        element.packageList.forEach((res) => {
          packagelist += res.display + " , ";
        });
      }
    
      const appointment:AppointmentModel = {
        countryCode :countryCode,
        token:token,
        patientId: patientId,
        doctorId: doctorId,
        doctorName: element.doctor ? element.doctor.display : "",
        specialty: element.specialty
          ? element.specialty[0].coding[0].display
          : "",
        mrnNumber: mrn,
        patientImage: this.getGenderValue(
          gender
        ),
        patientName: name,
        PatientAge: this.calculateAge(agecalculate),
        age :this.convertDateFormat(dateofbirth)+genderv,
        PatientGender:
          gender + " / " + dob.years + " " + dob.months + " " + dob.days,
        patientCode: element.participant[0].type[0].coding[0].code,
        createdDate: element.created,
        appointmentDate: language=="th" ?_this.thConvertService.convertToThaiFullDate(element.start) :element.start,
        endDate:element.epochEndDateTime,
        patientResponse: element.patientResponse,
        patientResponseTime:element.patientResponseTime,
        status: statusMultiLang,
        comment: element.remarks,
        app: element,
        patientType: patientTypemulti,
        type : element.patientType ? element.patientType.code :"",
        patientMrn: mrn,
        checkInTime: element.checkInTime,
        checkIn: checkIn,
        bookingType: element.serviceCategory
          ? element.serviceCategory.display
          : "",
        bookingTypeCode: element.serviceCategory
          ? element.serviceCategory.code
          : "",
        isAppoinmentConfirmed: element.isAppoinmentConfirmed
          ? element.isAppoinmentConfirmed
          : false,

        company: element.company ? element.company.display : "",
        appNo: element.identifier[0].value,
        apptSelection: false,
        id: element.id,
        previousRemarks: element.internalRemark ? element.internalRemark : [],
        rescheduleRemarks: element.rescheduleRemarks
          ? element.rescheduleRemarks
          : "",
        cancelRemarks:element.remarks?element.remarks:"",
        rescheduleReason: element.reason ? element.reason[0].display : "",
        specialReq: speciality ? speciality.slice(0, -2) : "",
        specialRequirements: element.specialRequirements,
        package:packagelist?packagelist.slice(0,-2):"",
        packageValue:element.packageList ? element.packageList[0].display :"",
        mobileNo:mobileNO,
        selected: isSelcted,
        isVip:vipFlag,
        gender:gender?gender:'',
        servicer : element.serviceCategory && element.serviceCategory.coding? element.serviceCategory.coding[0].display:
        element.serviceCategory ? element.serviceCategory.display :"",
         isNoteVisible:element.patientNoteDetails?element.patientNoteDetails.note:"",
         appointmentType:appointmentType?appointmentType:'',
          appointmentTypeCode:appointmentTypeCode?appointmentTypeCode:'',
         patientCategoryCode:patientCategoryCode?patientCategoryCode:'',
          calledStatus : calledStatus ? calledStatus : '',
          appoinmentPriorityCode: element.priority? element.priority.code : "",
        priority: element.priority? element.priority.display : "",
        specialInstruction: element.specialInstruction? element.specialInstruction : "",
        needTranslator: element.needTranslator ? element.needTranslator : false,
        translatorLanguage : element.translatorLanguage ? element.translatorLanguage : "",
        displayTitle : displayTitle,
        patientNameLangBase : patientNameLangBase
      };

      _this.statusList["all"].push(appointment);
      if (element.status) {
        _this.statusList[element.status].push(appointment);
      }
    });
    return _this.statusList.all;
  }
  getGenderValue(value: string): string {
    switch (value) {
      case "MALE":
        return "male-blue.png";
      case "FEMALE":
        return "female-pink.png";
      default:
        return "male-blue.png";
    }
  }
 convertDateFormat(dateStr: string): string {
  if (!dateStr) {
    return '';
  }

  let parsedDate: Date;

  if (!isNaN(Date.parse(dateStr))) {
    parsedDate = new Date(dateStr);
  } else {
    const cleanedStr = dateStr.replace(/MYT|GMT|UTC|IST|[A-Z]{3,}/g, '').trim();
    const parsed = Date.parse(cleanedStr);
    if (isNaN(parsed)) {
      return '';
    }
    parsedDate = new Date(parsed);
  }

  const day = ("0" + parsedDate.getDate()).slice(-2);
  const month = ("0" + (parsedDate.getMonth() + 1)).slice(-2);
  const year = parsedDate.getFullYear();

  return `${day}-${month}-${year} / `;
}

  formatDateWithRelativeTime(date: Date): string {
    if (!date) {
      return '';
    }
    let newDate = new Date();
    const relativeTime = moment(date).fromNow(); 
    return `(${relativeTime})`;
  }
calculateAge(dateOfBirth: string): string {
  if (!dateOfBirth) {
    return '';
  }

  let birthDate: Date;

  if (!isNaN(Date.parse(dateOfBirth))) {
    birthDate = new Date(dateOfBirth);
  } else {
    const parsed = Date.parse(dateOfBirth.replace(/MYT|GMT|UTC|IST|[A-Z]{3,}/g, ''));
    if (isNaN(parsed)) {
      return '';
    }
    birthDate = new Date(parsed);
  }

  const currentDate = new Date();
  let years = currentDate.getFullYear() - birthDate.getFullYear();
  let months = currentDate.getMonth() - birthDate.getMonth();
  let days = currentDate.getDate() - birthDate.getDate();

  if (days < 0) {
    months--;
    days += new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
  }
  if (months < 0) {
    years--;
    months += 12;
  }

  return `${years} Y, ${months} M, ${days} D`;
}
}
